import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

const FormGroup = ({ children }) => <Box sx={{ mb: 2 }}>{children}</Box>;

const AddigyConnectForm = ({ onSubmit, guideMode, savedFormValues }) => {
  const [clientConsoleURL, setClientConsoleURL] = useState("");
  const [orgId, setOrgId] = useState("");
  const [APIToken, setAPIToken] = useState("");
  const [error, setError] = useState("");
  const [showAPIToken, setShowAPIToken] = useState(false);

  const normalizeConsoleUrl = (url) => {
    if (!url) return url;
    let u = url.trim();
    if (!/^https?:\/\//i.test(u)) {
      u = `https://${u}`;
    }
    try {
      const parsed = new URL(u);
      return `${parsed.protocol}//${parsed.hostname}`;
    } catch (_e) {
      const parts = u.split("/");
      return parts.slice(0, 3).join("/");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Basic validation
    if (!clientConsoleURL) {
      setError("Your Console URL is required");
      return;
    }
    if (!orgId) {
      setError("Org ID is required");
      return;
    }
    if (!APIToken) {
      setError("API Token is required");
      return;
    }

    // Normalize URL to ensure it ends with /api/v2/
    const normalizedConsoleURL = normalizeConsoleUrl(clientConsoleURL);

    // Submit the form data
    onSubmit({
      credentials: {
        clientConsoleUrl: normalizedConsoleURL,
        orgId: orgId,
        apiToken: APIToken,
      },
    });
  };

  const handleClickShowAPIToken = () => {
    setShowAPIToken(!showAPIToken);
  };

  const handleMouseDownShowAPIToken = (e) => {
    e.preventDefault();
  };

  return (
    <Box component="form" onSubmit={handleSubmit} width={700}>
      <FormGroup>
        <Typography variant="subtitle1">Console URL</Typography>
        <TextField
          placeholder="Console URL (e.g., https://app.addigy.com)"
          fullWidth
          value={clientConsoleURL}
          onChange={(e) => setClientConsoleURL(e.target.value)}
          disabled={guideMode}
        />
      </FormGroup>
      <FormGroup>
        <Typography variant="subtitle1">Org ID</Typography>
        <TextField
          placeholder="Your Org ID"
          fullWidth
          value={orgId}
          onChange={(e) => setOrgId(e.target.value)}
          disabled={guideMode}
        />
      </FormGroup>
      <FormGroup>
        <Typography variant="subtitle1">API token</Typography>
        <TextField
          placeholder="Your API token"
          fullWidth
          type={showAPIToken ? "text" : "password"}
          value={APIToken}
          onChange={(e) => setAPIToken(e.target.value)}
          disabled={guideMode}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle api key visibility"
                  onClick={handleClickShowAPIToken}
                  onMouseDown={handleMouseDownShowAPIToken}
                >
                  {showAPIToken ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </FormGroup>
      {error && (
        <Typography color="error" variant="body2" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
      <Box display="flex" justifyContent="center">
        <PrimaryButton type="submit" disabled={guideMode}>
          Connect
        </PrimaryButton>
      </Box>
    </Box>
  );
};

export default AddigyConnectForm;
